module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "header-bar"
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    on: {
      "click": _vm.back
    }
  }), _vm._v(" "), _c('span', [_vm._v("av" + _vm._s(_vm.aid))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('div', [_c('video', {
    staticClass: "video",
    attrs: {
      "controls": "controls",
      "src": _vm.videoSrc
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "play-desc"
  }, [_c('ul', [_c('li', {
    staticClass: "info",
    on: {
      "click": _vm.toggleInfo
    }
  }, [_vm._v("简介")]), _vm._v(" "), _c('li', {
    staticClass: "comment",
    on: {
      "click": _vm.toggleComment
    }
  }, [_vm._v("评论(" + _vm._s(_vm.comment.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isInfoShow),
      expression: "isInfoShow"
    }],
    staticClass: "show-info"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.searchTitle))]), _vm._v(" "), _c('p', {
    staticClass: "desc"
  }, [_vm._v("【简介】:   " + _vm._s(_vm.searchDesc))]), _vm._v(" "), _c('p', {
    staticClass: "about"
  }, [_vm._v("【标签相关】")]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_c('img', {
    attrs: {
      "src": "https://ooo.0o0.ooo/2017/06/30/595605552345a.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('h4', [_vm._v("UP主:")]), _vm._v(" "), _c('p', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.searchAuthor))]), _vm._v(" "), _c('div', {
    staticClass: "follow",
    style: (_vm.follow),
    on: {
      "click": _vm.following
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.message))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCommentShow),
      expression: "isCommentShow"
    }],
    staticClass: "show-comment"
  }, [_c('ul', {
    staticClass: "cmt-list"
  }, _vm._l((_vm.comment), function(cmt, index) {
    return _c('li', [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": cmt.member.avatar,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(cmt.member.uname))]), _vm._v(" "), _c('span', {
      staticClass: "ico"
    }, [_c('i', {
      staticClass: "fa fa-thumbs-o-up"
    }), _vm._v(_vm._s(cmt.like) + "\n          ")]), _vm._v(" "), _c('p', {
      staticClass: "comment-msg"
    }, [_vm._v(_vm._s(cmt.content.message))])])
  })), _vm._v(" "), _c('div', {
    staticClass: "talk"
  }, [_c('img', {
    staticClass: "emoji",
    attrs: {
      "src": require("../assets/img/emoji.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cmtContent),
      expression: "cmtContent"
    }],
    attrs: {
      "type": "text",
      "placeholder": "说点什么把"
    },
    domProps: {
      "value": (_vm.cmtContent)
    },
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submitCmt($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cmtContent = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "send",
    attrs: {
      "src": require("../assets/img/send.png"),
      "alt": ""
    },
    on: {
      "click": _vm.submitCmt
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5f1c95a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/searchPlay.vue
// module id = 116
// module chunks = 0